export const DEFAULT_VISIBILITY_TIMEFRAME = '30d';

export const VISIBILITY_TIMEFRAME_OPTIONS = [
  ['7d', 'Last 7 days'],
  ['14d', 'Last 14 days'],
  ['30d', 'Last 30 days'],
  ['90d', 'Last 90 days'],
  ['180d', 'Last 6 months'],
  ['12m', 'Last 12 months'],
  ['all', 'Lifetime'],
];

export function visibilityDeltaDirection(value) {
  if (typeof value !== 'number') return 'unavailable';
  if (value > 0) return 'up';
  if (value < 0) return 'down';
  return 'flat';
}

export function visibilityDeltaTitle(basis) {
  if (basis === 'zero_baseline') {
    return 'Tracking started in this period; change measured from 0%';
  }
  if (basis === 'lifetime') {
    return 'Change versus the first half of tracking';
  }
  return undefined;
}

export function promptSummaryCacheKey(campaignId, timeframe, showArchived) {
  return `${campaignId}:${timeframe}:${Boolean(showArchived)}`;
}
